module.exports = __webpack_public_path__ + "assets/img/service_b2.683fff0b.png";